export default "__VITE_ASSET__cCiXvFeV__"